import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ResellersListItem } from "../../resellers.types";
import { requestGetResellers } from "./getResellers.request";

const useGetResellers = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<ResellersListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", "admin", "many", requestParams],
    queryFn: async () => await requestGetResellers(requestParams),
    ...options
  });

  return { resellers: data?.data, meta: data?.meta, ...rest };
};

export default useGetResellers;
